import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { COLORS, GRADIENTS } from '../themeConstants';
import studImg from '../../../static/images/stud.png';
import statImg from '../../../static/images/stat.png';

const features = [
	{
		title: 'Academic',
		description: 'Transform learning with tech-driven Attendance, OBE, FYUGP, and Planning.',
		icon: '🎓',
		image: '/images/features/academic.png',
		gradient: 'from-blue-500/20 to-cyan-500/20',
	},
	{
		title: 'Co-Curricular',
		description: 'Boost growth with dynamic Arts, Sports, Clubs, and Cells.',
		icon: '🎭',
		image: '/images/features/co-curricular.png',
		gradient: 'from-purple-500/20 to-pink-500/20',
	},
	{
		title: 'Compliance',
		description: 'Automate workflows for NAAC 2024, NIRF, KIRF, AISHE, and more.',
		icon: '📋',
		image: '/images/features/compliance.png',
		gradient: 'from-amber-500/20 to-orange-500/20',
	},
	{
		title: 'Administration',
		description: 'Unify operations, finance, HR, and resources on one platform.',
		icon: '⚙️',
		image: '/images/features/administration.png',
		gradient: 'from-emerald-500/20 to-teal-500/20',
	},
];

const FeatureCard = ({ feature, isSelected, onClick }) => (
	<motion.div
		className={`relative p-3 rounded-2xl cursor-pointer transition-all duration-500
      ${COLORS.background.glass} backdrop-blur-md 
      ${isSelected ? 'scale-105 shadow-2xl' : 'hover:scale-102 shadow-xl'}
      ${isSelected ? 'shadow-light' : ''}`}
		onClick={onClick}
		whileHover={{ y: -5 }}
		initial={{ opacity: 0, y: 20 }}
		animate={{ opacity: 1, y: 0 }}>
		<div className={`absolute inset-0 rounded-2xl bg-gradient-to-br ${feature.gradient} opacity-50 dark:opacity-10`} />
		<div className='relative z-10'>
			<span className='text-2xl mb-4 block'>{feature.icon}</span>
			<h3 className={`text-base font-bold ${COLORS.text.primary} mb-2`}>{feature.title}</h3>
			<p className={`${COLORS.text.secondary} text-[10px]`}>{feature.description}</p>
		</div>
	</motion.div>
);

const FeatureShowcase = () => {
	const [selectedFeature, setSelectedFeature] = useState(0);

	return (
		<div className='mt-16 relative px-10'>
			<div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12'>
				{features.map((feature, index) => (
					<FeatureCard key={index} feature={feature} isSelected={selectedFeature === index} onClick={() => setSelectedFeature(index)} />
				))}
			</div>
		</div>
	);
};

export default FeatureShowcase;
